import type { Metric, MetricDelta } from "../types/reports.types";

function getDeltaSymbol(delta?: MetricDelta): string {
  if (delta === "up")      return "↑";
  if (delta === "down")    return "";
  if (delta === "neutral") return "↔";
  return "";
}

interface MetricCardProps {
  metric: Metric;
}

export default function MetricCard({ metric }: MetricCardProps) {
  return (
    <article className="metricCard">
      <p className="metricLabel">{metric.label}</p>
      <p className="metricValue">{metric.value}</p>
      <p className={`metricDelta ${metric.delta ?? "neutral"}`}>
        <span>{getDeltaSymbol(metric.delta)}</span>
        {metric.note}
      </p>
    </article>
  );
}
